import { render, staticRenderFns } from "./TeamCrestOptions.vue?vue&type=template&id=0ae1efc2&scoped=true"
import script from "./TeamCrestOptions.vue?vue&type=script&lang=js"
export * from "./TeamCrestOptions.vue?vue&type=script&lang=js"
import style0 from "./TeamCrestOptions.vue?vue&type=style&index=0&id=0ae1efc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae1efc2",
  null
  
)

export default component.exports